<template>
<div>
    <el-row style="margin-bottom:20px;">
        <el-col :lg="6" :offset="2">
            品牌: {{this.memberList.brand_id == 1 ? 'N牌': 'S牌'}}
        </el-col>
        <el-col :lg="8">
            卡號: {{this.memberList.card_number}}
        </el-col>
        <el-col :lg="8">
            卡別: {{this.memberList.level == 1 && this.memberList.brand_id == 1 ? '白金':''}}
            {{this.memberList.level == 2 && this.memberList.brand_id == 1 ? '尊爵':''}}
            {{this.memberList.level == 1 && this.memberList.brand_id == 2 ? '芙蓉':''}}
            {{this.memberList.level == 2 && this.memberList.brand_id == 2 ? '金鑽':''}}
        </el-col>
    </el-row>
    <el-row style="margin-bottom:20px;">
        <el-col :lg="6" :offset="2">
            入會日期: {{this.memberList.vip_start_at}}
        </el-col>
        <el-col :lg="8">
            到期日: {{this.memberList.vip_end_at}}
        </el-col>
        <el-col :lg="8">
            累積金額: {{this.memberList.consumption}}
        </el-col>
    </el-row>
    <el-row style="margin-bottom:20px;">
        <el-col :lg="6" :offset="2">
            建檔日期: {{this.memberList.make_day}}
        </el-col>
        <el-col :lg="8">
            建檔到期日: {{this.memberList.make_end}}
        </el-col>
        <el-col :lg="8">

        </el-col>
    </el-row>
    <el-row>
        <el-col :lg="22">
            <el-table :data="cardList">
                <el-table-column label="申辦日期" prop="date_start"></el-table-column>
                <el-table-column label="卡號" prop="card_number"></el-table-column>
                <el-table-column label="建檔日期" prop="make_day"></el-table-column>
                <el-table-column label="建檔到期日" prop="make_end"></el-table-column>
                <el-table-column label="卡別">
                    <template slot-scope="scope">
                        {{scope.row.level_to == 0 ? '非會員': ''}}
                        {{scope.row.level_to == 1 && scope.row.brand_id == 1 ? '白金': ''}}
                        {{scope.row.level_to == 2 && scope.row.brand_id == 1 ? '尊爵': ''}}
                        {{scope.row.level_to == 1 && scope.row.brand_id == 2 ? '芙蓉': ''}}
                        {{scope.row.level_to == 2 && scope.row.brand_id == 2 ? '金鑽': ''}}
                    </template>
                </el-table-column>
                <el-table-column label="申辦項目">
                    <template slot-scope="scope">
                        {{scope.row.type == 0 ? '建檔': ''}}
                        {{scope.row.type == 1 ? '升級': ''}}
                        {{scope.row.type == 2 ? '續卡': ''}}
                        {{scope.row.type == 3 ? '降級': ''}}
                    </template>
                </el-table-column>
                <el-table-column label="申辦人員" prop="user_name"></el-table-column>
                <el-table-column label="櫃點" prop="shop_name"></el-table-column>
                <el-table-column label="到期日" prop="date_end"></el-table-column>
            </el-table>

        </el-col>
    </el-row>

</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
    name: 'card',
    props: {
        memberKey: String
    },
    data() {
        return {
            memberList: {},
            cardList: []
        }
    },
    computed: mapGetters(['getMemberDetail', "getVipList"]),
    methods: {
        ...mapActions(['fetchMemberDetail', "fetchVipList"]),
        async fetchmember() {
            const data = {
                _key: this.memberKey
            }
            await this.$store.dispatch('fetchMemberDetail', data)
            this.memberList = this.getMemberDetail
        },
        async fetchVipList() {
            const data = {
                _key: this.memberKey
            }
            await this.$store.dispatch('fetchVipList', data)
            this.cardList = this.getVipList
        }
    },
    created() {
        this.fetchmember()
        this.fetchVipList()
    },

}
</script>
